import { Outlet } from 'react-router-dom';

import NotFound from '~/pages/NotFound';

export default function AuditHistoryWrapper() {
  if (/audit-history\/?$/i.test(globalThis.location.pathname)) {
    return <NotFound />;
  }

  return <Outlet />;
}
